import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	// Owner and Levitate User cells hold full Dynamics display names, which the 512px default clips.
	popup: {
		maxWidth: 900,
	},
	summary: {
		display: 'flex',
		gap: THEME.spacing.lg,
		flexWrap: 'wrap',
		marginBottom: THEME.spacing.md,
	},
	summaryItem: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	summaryLabel: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	summaryValue: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	unresolvedValue: {
		color: THEME.colors.warning.dark,
	},
	rows: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		maxHeight: 320,
		overflowY: 'auto',
		...THEME.common.scrollBar,
	},
	row: {
		display: 'grid',
		gridTemplateColumns: '48px 1fr 1fr 140px',
		gap: THEME.spacing.sm,
		alignItems: 'center',
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		borderBottom: THEME.common.border,
		fontSize: THEME.typography.fontSizes.sm,
	},
	headerRow: {
		fontWeight: THEME.typography.fontWeights.bold,
		backgroundColor: THEME.colors.background.main,
		position: 'sticky',
		top: 0,
	},
	rowNumber: {
		color: THEME.colors.text.light,
	},
	filterLabel: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	reassignedValue: {
		color: THEME.colors.primary.dark,
	},
	// minWidth 0 so the column can shrink: a grid item defaults to min-width auto, which lets a long name widen the
	// column instead of ellipsising, pushing the result badge out of view.
	cell: {
		display: 'flex',
		flexDirection: 'column',
		minWidth: 0,
	},
	linkedMarker: {
		color: THEME.colors.text.light,
	},
	secondaryLine: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xxs,
	},
	truncate: {
		...THEME.common.truncate,
	},
	blockedNotice: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	fileSection: {
		alignItems: 'flex-start',
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		marginBottom: THEME.spacing.md,
	},
	fileName: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		overflowWrap: 'anywhere',
	},
	hiddenFileInput: {
		display: 'none',
	},
	filterBar: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		marginBottom: THEME.spacing.sm,
	},
});
